module.exports = __webpack_public_path__ + "static/media/man.a11012b6.png";